import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

export default class extends Controller {
  static values = { delay: { type: Number, default: 5000 } }

  connect() {
    this.remove = this.remove.bind(this)
    this.element.addEventListener("hidden.bs.toast", this.remove, { once: true })
    this.instance = Toast.getOrCreateInstance(this.element, {
      autohide: true,
      delay: this.delayValue
    })
    this.instance.show()
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.toast", this.remove)
    this.instance?.dispose()
  }

  remove() {
    this.element.remove()
  }
}
